import React, { useState, useRef } from "react";
import SVG_FireIcon from "../../assets/images/svgs/fire.svg?react";
import SVG_SpadeIcon from "../../assets/images/svgs/spade.svg?react";
import SVG_ChevronLeftIcon from "../../assets/images/svgs/chevronleft.svg?react";
import SVG_ChevronRightIcon from "../../assets/images/svgs/chevronRight.svg?react";
import HomeCasinoProviderList from "./HomeCasinoGrid/HomeCasinoProviderList";
import IndianCardGameGridList from "./HomeCasinoGrid/IndianCardGameGridList";
import HomePopularGameGridList from "./HomeCasinoGrid/HomePopularGameGridList";
import ContinueGameList from "./HomeCasinoGrid/ContinueGameList";
import { USER_DATA } from "../../config/app.config";
import { LeftArrowSVG, RightArrowSVG } from "../SvgImage/SvgImage";
import { UNICON_THEME } from "../../config/api.config";

const HomeCasinoGrid = ({ itemHeaderData, games }) => {
  const [seeAll, setSeeAll] = useState(false);
  const scrollContainerRef = useRef();

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const existingGame =
    games && Array.isArray(games)
      ? games
      : JSON.parse(localStorage.getItem(userData?._id)) || [];

  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        left: scrollContainerRef.current.scrollLeft - 150,
        behavior: "smooth",
      });
    }
  };

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        left: scrollContainerRef.current.scrollLeft + 150,
        behavior: "smooth",
      });
    }
  };

  const renderHeader = () => {
    return (
      <div
        className={`flex items-center w-full py-2 px-2.5 gap-1 rounded-t-[4px] ${
          games && Array.isArray(games) ? " !pb-0" : "bg-bg_Quaternary"
        }`}
      >
        {itemHeaderData.name == "casino Providers" ||
        itemHeaderData.name == "Popular Games" ? (
          <SVG_FireIcon />
        ) : itemHeaderData.name == "Indian Card Games" ? (
          <SVG_SpadeIcon />
        ) : null}

        <div className="w-[100%] flex flex-row justify-between">
          {itemHeaderData.name == "Continue to Play" ? (
            <>
              {games && Array.isArray(games) ? (
                <span className={`font-lato text-text_Ternary
                  ${ UNICON_THEME ? "linear-gradient(95deg,#6e081d -8.6%, #6e081d 110.45%)" : "linear-gradient(95deg,#ef8402 -8.6%, #ef8402 110.45%)"}
                font-extrabold tracking-[0.3px] text-sm md:text-base lg:text-lg leading-[18px]`}>
                  Continue to Play
                </span>
              ) : (
                <span
                  className="text-sm capitalize whitespace-nowrap  text-center text-transparent bg-clip-text"
                  style={
                    {
                    backgroundImage:
                     UNICON_THEME ? "linear-gradient(95deg,#6e081d -8.6%, #6e081d 110.45%)" : "linear-gradient(95deg,#ef8402 -8.6%, #ef8402 110.45%)",
                    fontWeight: "700",
                  }}
                >
                  Continue to Play
                </span>
              )}
            </>
          ) : (
            <span className="text-text_Ternary font-semibold capitalize">
              {itemHeaderData.name}
            </span>
          )}

          <div className="flex w-[108.75px] items-center justify-end gap-[5px]">
            <button
              className="inline-block  leading-normal relative overflow-hidden   transition duration-150 ease-in-out font-lato bg-bg_text_brand_secondary text-transparent bg-clip-text font-semibold text-[12px] leading-[18px] transition-all ease-in-out duration-200 cursor-pointer"
              type="button"
              onClick={() => {
                setSeeAll(!seeAll);
              }}
            >
              {!seeAll ? "See All" : "See Less"}
            </button>
            <button
              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out flex w-[22px] h-[22px] p-1 justify-center items-center gap-[10px] text-text_Primary  bg-bg_Foundation rounded  cursor-pointer"
              type="button"
              onClick={() => {
                handleScrollLeft();
              }}
            >
              {/* <SVG_ChevronLeftIcon /> */}
              <LeftArrowSVG />
            </button>
            <button
              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out flex w-[22px] h-[22px] p-1 justify-center items-center gap-[10px] text-text_Primary  bg-bg_Foundation rounded  cursor-pointer"
              type="button"
              onClick={() => {
                handleScrollRight();
              }}
            >
              {/* <SVG_ChevronRightIcon /> */}
              <RightArrowSVG />
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      title={itemHeaderData.name}
      className={`py-1 px-[${games && Array.isArray(games) ? 0 : 6}px] w-full`}
    >
      <div
        className={`flex flex-col w-full ${
          games && Array.isArray(games) ? "" : "bg-bg_Quaternary"
        } rounded-[4px] shadow-homeCasinoCardGamesShadow divide-y`}
      >
        {!!itemHeaderData ? renderHeader() : null}

        <div
          id="scrollShow"
          className={`py-2.5 px-${
            games && Array.isArray(games) ? "0" : "2.5"
          } transition-all ease-in-out duration-200 w-full h-max overflow-x-auto`}
          ref={scrollContainerRef}
        >
          {itemHeaderData.name == "casino Providers" && (
            <HomeCasinoProviderList seeAll={seeAll} />
          )}

          {itemHeaderData.name == "Indian Card Games" && (
            <IndianCardGameGridList seeAll={seeAll} />
          )}

          {itemHeaderData.name == "Popular Games" && (
            <HomePopularGameGridList seeAll={seeAll} />
          )}

          {itemHeaderData.name == "Continue to Play" && (
            <ContinueGameList Data={existingGame} seeAll={seeAll} />
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeCasinoGrid;
